// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"42ca0799","204":"26453407"}[chunkId] + ".chunk.css";
};